import styled, { CSSProperties } from 'styled-components';
import { Checkbox } from 'react-inv-forms';

import { variables } from '../../../styles/variables';

export const NotificationAdminContainer = styled.article``;

export const BoldText = styled.p`
  font-weight: 700;
  margin: 0;
`;

interface SingleNotificationViewContainerProps {
  children: React.ReactNode;
  borderTop: boolean;
}

export const SingleNotificationViewContainer = styled.article<SingleNotificationViewContainerProps>`
  padding: 1rem 0 2rem 0;
  border-top: ${props => (props.borderTop ? undefined : `1px solid ${variables.colorBorder}`)};
`;

export const CheckboxStyled = styled(Checkbox)`
  span {
    font-size: 14px;
    color: ${variables.colorMainTextOpacity};
  }
`;

export const NotificationStyle: CSSProperties = {
  overflowY: 'auto',
  maxHeight: '92vh',
  wordBreak: 'break-word',
};
